<script setup>
import { formatDecimals } from '@/helpers/stringHelpers'
import { defineProps } from 'vue'

defineProps({
  headers: {
    type: Array,
    default: () => []
  },
  items: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const sortby = 'weight'
const sortDesc = true
</script>

<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      dense
      item-key="id"
      :sort-by="sortby"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading..."
      hide-default-footer
      disable-pagination
      class="elevation-1"
    >
      <template #[`item.weight`]="{ item }">
        {{ formatDecimals(item.weight) }}
      </template>
    </v-data-table>
  </div>
</template>
